import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initializeFirebaseData } from './utils/firebaseInit';

// Initialize Firebase data
initializeFirebaseData().catch(console.error);

// Wait for DOM to be fully loaded before trying to access the root element
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('root');
  
  if (rootElement) {
    createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } else {
    console.error('Root element not found. Make sure there is a div with id="root" in your HTML.');
  }
});